import React, {useState, useEffect} from 'react';

import {isEmpty} from "../../utils/validations";
import {getAllEvents} from "../../knowledgeBank/KnowledgeBankAction";

import EventsView from "./EventsView";

const Events = (props) => {
    const [eventState, setEventState] = useState({
        events: [],
        isApiInProgress: false,
        apiErrorMessage: '',
        open: false,
        vertical: 'top',
        horizontal: 'right',
    });

    useEffect(() => {
        getEvents();
    }, []);

    const handleClick = (newState) => () => {
        setEventState(prevState => ({
            ...prevState,
            ...newState,
            open: true,
        }));
    };

    const handleClose = () => {
        setEventState(prevState => ({
            ...prevState,
            open: false,
        }));
    };

    const copyToClipboard = (url) => {
        navigator.clipboard.writeText(url)
            .then(
                handleClick({vertical: 'top', horizontal: 'right'})
            )
            .catch(err => {
                console.error('Error copying text: ', err);
            });
    };

    const getEvents = () => {
        setEventState(prevState => ({
            ...prevState,
            isApiInProgress: true,
        }));
        getAllEvents()
            .then(res => {
                if (res.success) {
                    setEventState(prevState => ({
                        ...prevState,
                        isApiInProgress: false,
                        events: (isEmpty(res.data) || isEmpty(res.data.events)) ? [] : res.data.events,
                    }));
                } else {
                    setEventState(prevState => ({
                        ...prevState,
                        isApiInProgress: false,
                        apiErrorMessage: res.__error,
                    }));
                }
            });
    };

    return (
        <EventsView
            {...props}
            {...eventState}
            handleClose={handleClose}
            copyToClipboard={copyToClipboard}
        />
    );
};

export default Events;
